module.exports = __webpack_public_path__ + "img/espanyol.2a83ffb3.png";